import { Outlet } from "react-router-dom"

import Navbar from "../components/Navbar";
import { ChevronRightIcon } from '@heroicons/react/16/solid'
import { Link } from "react-router-dom"
import Footer from "../components/Footer";





const Layout = ({
  demo_is_active,
  set_demo_is_active,

  set_demo_modal_is_open,

  journey,
} : {
  demo_is_active : any
  set_demo_is_active : any

  set_demo_modal_is_open : any

  journey : any
}) => {


  
  return (
    <div className="bg-[#0C101D]">
      {/* <Navbar set_demo_modal_is_open={set_demo_modal_is_open} /> */}
      <Navbar
        banner={null}
        set_demo_modal_is_open={set_demo_modal_is_open}
        journey={journey}
      />
      <Outlet />
      <Footer 
        demo_is_active={demo_is_active}
        set_demo_is_active={set_demo_is_active}
        set_demo_modal_is_open={set_demo_modal_is_open}
        journey={journey}
      />
    </div>
  )
}

export default Layout;